import { render, staticRenderFns } from "./HomePageMainHeroFeature.vue?vue&type=template&id=5807f0e3&scoped=true&"
import script from "./HomePageMainHeroFeature.vue?vue&type=script&lang=js&"
export * from "./HomePageMainHeroFeature.vue?vue&type=script&lang=js&"
import style0 from "./HomePageMainHeroFeature.vue?vue&type=style&index=0&id=5807f0e3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5807f0e3",
  null
  
)

export default component.exports